import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RankipediaService } from '@app/services/rankipedia.service';
import { Utilities } from '@app/services/utilities';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ContentDetailReturnModel } from '@app/models/content-detail-return.model';
import { ContentDetailModel, ContentDetailSectionModel } from '@app/models/content-detail.model.';
import { ContentSectionModel } from '@app/models/content-section.model';
import { ContentPageActions } from '@app/models/enums';
import { LocalStoreManager } from '@app/services/local-store-manager.service';
import { DBkeys } from '@app/services/db-keys';

@Component({
  selector: 'app-content-page',
  templateUrl: './content-page.component.html',
  styleUrls: ['./content-page.component.scss']
})

export class ContentPageComponent implements OnInit {
  isLoading = true;
  hasContent = false;
  showError = false;
  key: string = '[blank]';
  content: ContentDetailReturnModel;
  private sub: any;
  sectionCount: number = 0;

  constructor(
    private route: ActivatedRoute,
    private _rankiService: RankipediaService,
    private localStorage: LocalStoreManager,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) { }
  
  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event) {
      const id = 0;
      navigator.sendBeacon('/content/UpdateContentAction?contentKey=' + this.key + '&updateType=' + ContentPageActions.PageClosed + '&id=' + id);
  }

  ngOnInit(): void {
    this.sub = this.route.params.subscribe(params => {
      if (params['key']) {
        this.key = params['key'];                                                                                       // (+) converts string to a number (for future reference)
      }
     this.initData();
   });
  }

  ngAfterViewInit() {
                          
  }
  
  onClickMedia(type, contentElement) {
    console.log('clicked media!');
    var id = 0;
    let action = ContentPageActions.PageContentViewed;

    let element = contentElement.currentTarget;
    if (element != undefined) {
      var idElem = element.getAttribute('data-id');
      if (idElem === undefined || idElem === null) {
        idElem = element.getAttribute('data-id-');                                                                      // in case denny doesn't remvoe this from the html
      }
      if (idElem != undefined && idElem != null) {
        id = idElem;
      }
    }
    this.updateActionHandler(action, id);
  }

  initData() {
    if (!Utilities.isBlankOrNull(this.key, '[blank]')) {
      this.getContentDetails(this.key);
    }
    else {
      //JUST ERROR / NOT FOUND MESSAGE
    }
  }

  getContentDetails(key: string) {
    this.showError = false;
    this.localStorage.deleteData(DBkeys.CONTENT_DETAILS, true);
    return this._rankiService.getContentDetails(key).subscribe(data => {
      if (data != null) {
         const dataContent = data.Data as ContentDetailReturnModel;
         this.content = dataContent;
         if (dataContent.ContentDetail.ServiceResponse == -1) {
          this.saveContentDetailsToLocalStorage(this.content);
          this.hasContent = true;
            if (dataContent.ContentSections && dataContent.ContentSections.length > 0) {
                  this.sectionCount = dataContent.ContentSections.length;
                  this.getContentSections(dataContent.ContentDetail.ContentPageID, dataContent.ContentDetail.Sections)
                  this.isLoading = false;
            }
          } 
          else {
            this.showError = true;
          }
      }
    }),
      catchError(err => {
        console.log(err);
        this.isLoading = false;
        return of<any>([]);
      });
  }

  saveContentDetailsToLocalStorage(content: ContentDetailReturnModel){
    this.localStorage.savePermanentData(content, DBkeys.CONTENT_DETAILS);
    // get email on server if possible using owner id and type
    // if (content.ContentDetail.Email){                                                                                //TODO - soon as set this ON it should work??
    //     this.localStorage.savePermanentData(content.ContentDetail.Email, DBkeys.LOCAL_KEY_EMAIL);
    // }
  }

  getContentSections(contentPageId: number, sections : ContentDetailSectionModel[]) {
    this._rankiService.getContentSections(contentPageId, sections).subscribe(data => {
      if (data != null) {
         const sections = data.Data as ContentSectionModel[];
         this.content.ContentSections = sections;
         this.hasContent = true;
         this.setEventHandlers(); 
      }
    }),
      catchError(err => {
        console.log(err);
        this.isLoading = false;
        return of<any>([]);
      });
  }

  setEventHandlers() {
    setTimeout(() => {
      var videos = document.getElementsByTagName('video');
      for (var i = 0; i < videos.length; i++) {
        var video = videos[i];
        video.addEventListener('click', this.onClickMedia.bind(this, 'video'));
      }
      var audios = document.getElementsByTagName('audio');
      for (var i = 0; i < audios.length; i++) {
        var audio = audios[i];
        audio.addEventListener('click', this.onClickMedia.bind(this, 'audio'));
      }     
    }, 1000);    
  }

  updateActionHandler(action: ContentPageActions, id: number) {
      if (!this.key) {
        return;
      }
      this._rankiService.updateContentAction(this.key, action, id).subscribe(data => {
        console.log('updated action for close in content page. key = ' + this.key);
      }),
        catchError(err => {
          console.log(err);
          return of<any>([]);
      });
  }
}
